exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Waypoints__step-3H {\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.2);\n  max-width: 20rem;\n  margin: 30vh 0;\n}\n\n.article .Waypoints__step-3H h4 {\n    margin: 0.5rem 0;\n  }\n\n.article .Waypoints__step-3H p {\n    margin-bottom: 0;\n    font-size: 0.85rem;\n  }\n", ""]);

// exports
exports.locals = {
	"step": "Waypoints__step-3H"
};